//公共的请求方法
import {login,permission} from './login/login'
import product from './product'
const api = {

  
  //产品信息接口---
  ...product,
  
  login,
};

export { permission }

//vue组件实例：this.$api.permission()
//导出对象 api身上挂载了很多方法
export default api;
